module.exports = __webpack_public_path__ + "static/media/servicios_publicos_8.8d1460d2.png";